import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Printer } from "lucide-react";

export default function ShootPlanner() {
  const [scripts, setScripts] = useState([]);
  const [shotLists, setShotLists] = useState({});

  useEffect(() => {
    api.get("/scripts").then(async (r) => {
      setScripts(r.data);
      const results = await Promise.all(r.data.map((s) => api.get(`/shot_lists/by_script/${s.id}`).then((x) => x.data).catch(() => null)));
      const map = {};
      r.data.forEach((s, i) => { if (results[i]?.id) map[s.id] = results[i]; });
      setShotLists(map);
    });
  }, []);

  const byLocation = {};
  Object.values(shotLists).forEach((sl) => {
    sl.items?.forEach((it) => {
      (byLocation[it.location] = byLocation[it.location] || []).push({ ...it, script: scripts.find((s) => s.id === sl.script_id) });
    });
  });

  return (
    <div className="p-8 max-w-[1400px]">
      <div className="mb-8 flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-1">Shoot Planner</div>
          <h1 className="text-5xl font-black tracking-tight leading-none" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Consolidated shoot day</h1>
        </div>
        <button data-testid="print-btn" onClick={() => window.print()} className="text-xs font-semibold px-3 py-2 rounded border border-neutral-300 hover:bg-neutral-50 flex items-center gap-1"><Printer className="w-3 h-3" />Print checklist</button>
      </div>

      {Object.keys(byLocation).length === 0 && (
        <div className="bg-white border border-dashed border-neutral-300 rounded-lg p-16 text-center text-neutral-500 text-sm">Generate shot lists from your approved scripts.</div>
      )}

      {Object.entries(byLocation).map(([loc, items]) => (
        <div key={loc} className="mb-8">
          <h2 className="text-2xl font-black tracking-tight mb-3" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>{loc.replace(/_/g, " ")} · {items.length} shots</h2>
          <div className="space-y-2">
            {items.map((it, i) => (
              <div key={i} data-testid={`shoot-${loc}-${i}`} className="bg-white border border-neutral-200 rounded p-3">
                <div className="flex items-center gap-2">
                  <input type="checkbox" className="w-4 h-4" />
                  <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold">{it.script?.title}</div>
                </div>
                <div className="text-sm mt-1">{it.shot_type} · {it.duration_seconds}s · {it.spoken_audio}</div>
                <div className="text-xs text-neutral-500 mt-1">{it.broll_action} · {it.props}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
